"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyValidation = void 0;
const NumericErrorMessages = {
  number: 'Must provide a valid number',
  currency: 'Must provide a valid dollar amount',
  percentage: 'Must provide a valid percentage',
  year: 'Must provide a valid year'
};
const SurveyStringMatchingValidations = {
  date: {
    match: /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/,
    error: 'Must provide a valid date'
  },
  email: {
    match: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    error: 'Must provide a valid email'
  },
  ssn: {
    match: /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/,
    error: 'Must provide a valid social security number'
  },
  phone_number: {
    match: /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/,
    error: 'Must provide a valid phone number'
  }
};

const SurveyValidation = (type, value, required) => {
  const stringValidator = SurveyStringMatchingValidations[type];

  if (stringValidator) {
    if (typeof value === 'string' && value.length) {
      if (!value.match(stringValidator.match)) {
        return stringValidator.error;
      }
    } else if (required) {
      return stringValidator.error;
    }

    return null;
  }

  const numericError = NumericErrorMessages[type];

  if (numericError) {
    if (value !== undefined) {
      if (typeof value !== 'number' || isNaN(value)) {
        return numericError;
      }
    } else if (required) {
      return numericError;
    }

    return null;
  }

  switch (type) {
    case 'multiple_select':
    case 'button_multiple_select':
      {
        if (value !== undefined) {
          if (!Array.isArray(value) || required && !value.length) {
            return `Must select one or more answers`;
          }
        } else if (required) {
          return `Must select one or more answers`;
        }

        return null;
      }

    case 'dropdown_select':
    case 'dropdown_select_only':
    case 'multiple_choice':
    case 'yes_or_no':
    case 'yes_no_or_unknown':
    case 'button_select':
      {
        if (Array.isArray(value)) {
          if (value.length > 1 || required && value.length !== 1) {
            return `Must select a single answer`;
          }
        } else if (value !== undefined) {
          if (typeof value === 'string' && !value) {
            return `Must select a single answer`;
          }
        } else if (required) {
          return `Must select a single answer`;
        }

        return null;
      }

    case 'text':
    case 'text_area':
      {
        if (required || value !== undefined) {
          if (typeof value !== 'string' || !value) {
            return `Must provide a valid answer`;
          }
        }

        return null;
      }

    case 'year_to_current':
      {
        const currentYear = new Date().getFullYear();
        const inputInteger = typeof value === 'string' ? parseInt(value, 10) : typeof value === 'number' ? value : undefined;

        if (inputInteger !== undefined) {
          if (!inputInteger || inputInteger < 1900 || inputInteger > currentYear) {
            return `Must provide a valid year between 1900 and ${currentYear}`;
          }
        } else if (required) {
          return `Must provide a valid year between 1900 and ${currentYear}`;
        }

        return null;
      }
  }
};

exports.SurveyValidation = SurveyValidation;